module.exports = __webpack_public_path__ + "img/04q-Shop_651.61d14f36.jpg";